import { transition, trigger, useAnimation } from '@angular/animations';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  Output,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import {
  fadeInFromTopAnimation,
  fadeOutToTopAnimation,
} from '../../../../../shared/animations/index';
import { UITheme } from '../../../../../shared/definitions/ui-theme.enum';
import { IconButtonIconTypes } from '../../../../ui-elements/constants/icon-button-icon-types.constant';
import { DropDownMenuItem } from '../../../models/drop-down-menu-item.model';

@Component({
  selector: 'drop-down-menu',
  standalone: false,
  templateUrl: './drop-down-menu.component.html',
  styleUrls: ['./drop-down-menu.component.scss'],
  host: {
    class: 'angular-component-wrapper',
  },
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('fadeInFromTopOutToTopAnimation', [
      transition(':enter', [
        useAnimation(fadeInFromTopAnimation, {
          params: {
            duration: '0.2s',
            delay: '0s',
          },
        }),
      ]),
      transition(':leave', [
        useAnimation(fadeOutToTopAnimation, {
          params: {
            duration: '0.2s',
            delay: '0s',
          },
        }),
      ]),
    ]),
  ],
})
export class DropDownMenuComponent implements OnDestroy {
  private readonly _renderer = inject(Renderer2);

  @Input() items: Array<DropDownMenuItem> = [];
  @Input() disabled: boolean = false;
  @Input() theme: UITheme;

  @Output() itemSelect: EventEmitter<string> = new EventEmitter<string>();

  menuState: boolean = false;

  iconButtonIconTypes = IconButtonIconTypes;
  get triggerIconButtonClasses() {
    const classes = [];

    classes.push(this.theme);

    if (this.menuState) {
      classes.push('simx-active');
    }

    return classes;
  }

  get menuClasses() {
    return ['simx-drop-down-menu--menu', this.theme];
  }

  windowClickListener: () => void;

  handleMenuTriggerClick(event: Event) {
    event.stopPropagation();

    if (this.disabled) {
      return;
    }

    this.toggleMenu();
  }

  handleMenuItemSelect(event: Event, selectedId: string) {
    event.stopPropagation();

    const item = this.items.find(item => item.id === selectedId);
    if (item.disabled) {
      return;
    }

    this.itemSelect.emit(selectedId);
    this.toggleMenu(false);
  }

  toggleMenu(state?: boolean) {
    const newState = state !== undefined ? state : !this.menuState;
    this.menuState = newState;

    if (newState) {
      this.windowClickListener = this._renderer.listen(
        'window',
        'click',
        (event: Event) => {
          this.toggleMenu(false);
        },
      );
    } else {
      if (this.windowClickListener) {
        this.windowClickListener();
      }
    }
  }

  ngOnDestroy() {
    if (this.windowClickListener) {
      this.windowClickListener();
    }
  }
}
